export const EDUCATION_PLACE = '/education_place/' as const
export const EDUCATION_PLACE_ALL = `${EDUCATION_PLACE}all` as const
